import * as React from 'react';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {CurtainModal} from './curtain-modal';

export function CampaignsCurtainModal() {
    const {onClose} = useOpenableModal(OpenableModals.CAMPAIGNS_ONBOARDING_MODAL);

    return <CurtainModal onClose={onClose} />;
}
